import fileHelper from '@/helpers/file.helper'
import documentEditorApi from '@/api/documentEditor.api'

const mixin = {
  computed: {
    toolbarItemId () {
      return {
        globalPlaceholder: 'globalPlaceholder',
        contactPlaceholder: 'contactPlaceholder',
        eventPlaceholder: 'eventPlaceholder',
        schedulePlaceholder: 'schedulePlaceholder',
        pdf: 'pdf',
        docx: 'docx'
      }
    }
  },

  methods: {
    getToolbarItem (id) {
      let item = null

      switch (id) {
        case this.toolbarItemId.globalPlaceholder: {
          item = {
            id,
            text: `${this.$t('documentEditor.global')} <div class="e-de-text-wrap">${this.$t('documentEditor.placeholder')}</div>`,
            tooltipText: this.$t('documentEditor.insertGlobalPlaceholder'),
            prefixIcon: 'p-de-icon-mdi mdi mdi-code-json'
          }
          break
        }
        case this.toolbarItemId.contactPlaceholder: {
          item = {
            id,
            text: `${this.$t('documentEditor.contact')} <div class="e-de-text-wrap">${this.$t('documentEditor.placeholder')}</div>`,
            tooltipText: this.$t('documentEditor.insertContactPlaceholder'),
            prefixIcon: 'p-de-icon-mdi mdi mdi-code-json'
          }
          break
        }
        case this.toolbarItemId.eventPlaceholder: {
          item = {
            id,
            text: `${this.$t('documentEditor.event')} <div class="e-de-text-wrap">${this.$t('documentEditor.placeholder')}</div>`,
            tooltipText: this.$t('documentEditor.insertEventPlaceholder'),
            prefixIcon: 'p-de-icon-mdi mdi mdi-code-json'
          }
          break
        }
        case this.toolbarItemId.schedulePlaceholder: {
          item = {
            id,
            text: `${this.$t('documentEditor.schedule')} <div class="e-de-text-wrap">${this.$t('documentEditor.placeholder')}</div>`,
            tooltipText: this.$t('documentEditor.insertSchedulePlaceholder'),
            prefixIcon: 'p-de-icon-mdi mdi mdi-code-json'
          }
          break
        }
        case this.toolbarItemId.pdf: {
          item = {
            id,
            text: 'PDF',
            tooltipText: this.$t('documentEditor.saveAsPdf'),
            prefixIcon: 'p-de-icon-mdi mdi mdi-file-pdf-box-outline'
          }
          break
        }
        case this.toolbarItemId.docx: {
          item = {
            id,
            text: 'DOCX',
            tooltipText: this.$t('documentEditor.saveAsDocx'),
            prefixIcon: 'p-de-icon-mdi mdi mdi-file-word-box-outline'
          }
          break
        }
      }

      return item
    },

    async saveAsPdf (editor, fileName) {
      const sfdt = editor.ej2Instances.documentEditor.serialize()
      const response = await documentEditorApi.exportToPdf(sfdt)
      const blob = new Blob([response.data], { type: 'application/pdf' })
      fileHelper.downloadFile(blob, fileName)
    },

    async saveAsDocx (editor, fileName) {
      const blob = await editor.ej2Instances.documentEditor.saveAsBlob('Docx')
      fileHelper.downloadFile(blob, fileName)
    },

    resetEditorSize () {
      // fix to make Syncfusion editor component take space properly (issue is related to the dialog transision)
      window.dispatchEvent(new Event('resize'))
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    }
  }
}

export default mixin
